import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import courseCDSStyle from './style';
import SingleWorkout from '../workoutsDisplay/singleWorkout';
import downloadCourse from '../../api/courses/download';

export default function CourseCDS({mt, bgImage, title, meta, nav, workoutTumbnail}) {
	let style = courseCDSStyle();
	let gContext = useContext(GlobalContext);
	let userID = gContext.user._id;
	let serverOrigin = gContext.serverOrigin;

	return (
		<div style={style.outerStyle(mt)}>
			<div style={style.imageElementStyle({bgImage: bgImage})}></div>
			<div style={style.imageLightenerStyle()}></div>
			<div style={style.contentCentererStyle()}>
				<h1 className='nice-header text-center px-3 text-black pt-5 pt-sm-0'>{title}</h1>
				<div style={style.lowerContentContainerStyle()}>
					<SingleWorkout
						addonStyle={style.singleWorkoutStyle()}
						name={title}
						showLinks={false}
						thumbnail={workoutTumbnail}
						addonClasses={style.singleWorkoutClasses()}
					/>
					<div style={style.lowerRightContainerStyle()} className={style.downloadPannelClasses()}>
						<p className='px-3 mt-3 mt-sm-0'>Thank you for purchasing this course</p>
						<p className='mt-3 px-3'>Course Content</p>
						<section className='mb-5 mb-sm-0' style={style.downloadPannelStyle()}>
							<div style={style.downloadMetaContainerStyle()}>
								<div style={style.outlinerStyle()}>
									<p style={style.outlinerText()}>PDF</p>
								</div>
								<p className='pt-3 ps-3 my-auto'>{meta.fileName}</p>
								<p className='pt-3 ps-3 my-auto'>{meta.fileSize}</p>
								<p className='pt-3 ps-3 my-auto'>{meta.pages} pages</p>
							</div>
							<div style={style.buttonsContainerStyle()}>
								<button onClick={downloadPrssed} style={style.buttonStyle()}>
									Download
								</button>
								<button onClick={nav.next} style={style.buttonStyle()}>
									Read Online
								</button>
								<button onClick={videoContentPressed} style={style.buttonStyle()}>
									Video Content
								</button>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	);

	function downloadPrssed() {
		downloadCourse(meta, userID, serverOrigin);
	}
	function videoContentPressed() {
		window.location.href = '/videocontent';
	}
}
